import type { FC } from "react";
import { useIntegration } from "../portals/messagemedia/hooks/useIntegration";
import { useValidateConnection } from "../portals/messagemedia/hooks/useValidateConnection";
import { getVendorChecks } from "../portals/messagemedia/vendorConfig";
import {
  IntegrationsContextProvider,
  type IntegrationsState,
} from "./integrations";

export const IntegrationsProviderWithData: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const vendorChecks = getVendorChecks();
  const isValidVendor =
    vendorChecks.isBrandMM ||
    vendorChecks.isBrandSE ||
    vendorChecks.isBrandAppSinch;

  const bigcommerceResult = useIntegration("bigcommerce", isValidVendor);
  const shopifyResult = useIntegration("shopify", isValidVendor);
  const woocommerceResult = useIntegration("woocommerce", isValidVendor);
  const mailjetResult = useIntegration("mailjet", isValidVendor);

  const shopifyConnection = useValidateConnection("shopify", isValidVendor);

  const integrationsState: IntegrationsState = {
    integrations: {
      bigcommerce: bigcommerceResult.data || null,
      shopify: shopifyResult.data || null,
      woocommerce: woocommerceResult.data || null,
      mailjet: mailjetResult.data || null,
    },
    integrationsLoading: {
      bigcommerce: bigcommerceResult.loading,
      shopify: shopifyResult.loading,
      woocommerce: woocommerceResult.loading,
      mailjet: mailjetResult.loading,
    },
    connectionStates: {
      shopify: shopifyConnection || null,
    },
  };

  return (
    <IntegrationsContextProvider integrationsState={integrationsState}>
      {children}
    </IntegrationsContextProvider>
  );
};
